import React from "react";

/** Placeholder for childcare-specific public detail fields (none yet). */
const ChildCare: React.FC = () => {
    return <></>;
};

export default ChildCare;
